import $script from 'scriptjs';

let promise;

export function loadFacebookSdk() {
    return promise ? promise : promise = new Promise((resolve) => {
        window.fbAsyncInit = () => {
            window.FB.init({
                appId: window.env.facebookAppId,
                status: true,
                cookie: true,
                xfbml: true,
                version: 'v2.4',
            });
            resolve(window.FB);
        };
        $script('https://connect.facebook.net/en_US/sdk.js');
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/load-facebook-sdk.js